import { render } from "./GuideCaution.vue?vue&type=template&id=75539ff6&scoped=true"
import script from "./GuideCaution.vue?vue&type=script&lang=js"
export * from "./GuideCaution.vue?vue&type=script&lang=js"

import "./GuideCaution.vue?vue&type=style&index=0&id=75539ff6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75539ff6"]])

export default __exports__